import React, { FC, useMemo } from 'react';
import { useLinkedBid } from 'src/models/bids/BidsSelector/hooks';
import styles from './index.module.scss';
import { OverviewQp } from 'src/models/procurements/types';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { useGetNewOverviewUrl } from 'src/models/procurements/hooks';
import { WorkspaceBadge } from 'src/common';

interface IProps {
  bidId: string;
}

export const LinkToBid: FC<IProps> = props => {
  const { bidId } = props;
  const bid = useLinkedBid(bidId);
  const getLinkOverview = useGetNewOverviewUrl();

  const href = useMemo(() => {
    return (
      bid &&
      getLinkOverview({
        [OverviewQp.WorkspaceId]: bid.workspace.id,
        [OverviewQp.PreviewId]: bid.id,
        [OverviewQp.PreviewMode]: SidebarMode.BID_INFO
      })
    );
  }, [bid, getLinkOverview]);

  return (
    <>
      {href && bid && (
        <a className={styles.link} href={href} target="_blank" rel="noopener noreferrer">
          <WorkspaceBadge
            title={bid.workspace.name}
            color={bid.workspace.color}
            mode={'short'}
            className={styles.badge}
          />
          <span className={styles.label}>{bid.name}</span>
        </a>
      )}
    </>
  );
};

export default LinkToBid;
